import * as types from './actionTypes';
import {clearDialog,setStandardDialog,setAssetDialog,setClickReveal,setScreenDialog} from '../helpers/dialogHelper';

export function setDialogPopup(dialogPopup){
    return { type: types.SET_DIALOG_POPUP, dialogPopup };
}

export function setContentToolTip(contentToolTip){
    return { type: types.SET_CONTENT_TOOLTIP, contentToolTip };
}

export function setClickRevealDialog(clickRevealDialog){
    return { type: types.SET_CLICK_REVEAL_DIALOG, clickRevealDialog };
}

export function setAssetDialogPopup(assetDialog){
    return { type: types.SET_ASSET_DIALOG, assetDialog };
}

export function setScreenDialogPopup(screenDialog){
    return { type: types.SET_SCREEN_DIALOG, screenDialog };
}


export function setNewDialog(config){
    return function(dispatch){
        return setStandardDialog(config).then(dialogPopup => {
            dispatch(setDialogPopup(dialogPopup));
        }).catch(error => {
            throw(error);
        });
    };
}

export function updateDialog(config){
    return function(dispatch, getState){
        const state = getState();
        let dialogPopup = state.dialogPopup;
        dialogPopup = Object.assign({},dialogPopup,{
            config: config
        });
        dispatch(setDialogPopup(dialogPopup));

    };
}

export function removeDialog(){
    return function(dispatch){
        return clearDialog().then(dialogPopup => {
            dispatch(setDialogPopup(dialogPopup));
        }).catch(error => {
            throw(error);
        });
    };
}

export function setToolTip(content){
    return function(dispatch){
        let contentToolTip = {
            render: true,
            content: content
        };
        dispatch(setContentToolTip(contentToolTip));
    };
}

export function hideToolTop(){
    return function(dispatch){
        let contentToolTip = {
            render: false,
            content: ""
        };
        dispatch(setContentToolTip(contentToolTip));
    };
}

export function setNewClickRevealDialog(config){
    return function(dispatch){
        return setClickReveal(config).then(clickRevealDialog => {
            dispatch(setClickRevealDialog(clickRevealDialog));
        }).catch(error => {
            throw(error);
        });
    };
}

export function removeClickRevealDialog(){
    return function(dispatch){
        return clearDialog().then(clickRevealDialog => {
            dispatch(setClickRevealDialog(clickRevealDialog));
        }).catch(error => {
            throw(error);
        });
    };
}

export function setNewAssetDialog(config){
    return function(dispatch){
        return setAssetDialog(config).then(dialogPopup => {
            dispatch(setAssetDialogPopup(dialogPopup));
        }).catch(error => {
            throw(error);
        });
    };
}

export function removeAssetDialog(){
    return function(dispatch){
        return clearDialog().then(dialogPopup => {
            dispatch(setAssetDialogPopup(dialogPopup));
        }).catch(error => {
            throw(error);
        });
    };
}

export function setNewScreenDialog(config){
    return function(dispatch){
        return setScreenDialog(config).then(screenDialog => {
            dispatch(setScreenDialogPopup(screenDialog));
        }).catch(error => {
            throw(error);
        });
    };
}

export function removeScreenDialog(){
    return function(dispatch){
        return clearDialog().then(screenDialog => {
            dispatch(setScreenDialogPopup(screenDialog));
        }).catch(error => {
            throw(error);
        });
    };
}


/** WEBPACK FOOTER **
 ** ./src/actions/dialogPopupActions.js
 **/